export const debounceTime = 1;

/**
 * Nombre minimum de caracteres saisis pour lancer une recherche d'autocompletion (Azure AD ou famille)
 */
export const autoCompleteMinLength = 3;

export const QCFieldComponentRoot = 'qcFieldComponentRoot';
